import PropTypes from 'prop-types';
import React from 'react';
import { WebStorageStateStore } from 'oidc-client';
import GenericUserManager, { userManagerTypes, oidcClientIds } from './GenericUserManager';

const BrowserUserManager = ({
  children,
  basePath,
  silentRedirectUri,
  oidcAuthority,
  clientId,
  postLogoutRedirectUri,
  onSessionLoaded,
  silentRenewDisabled,
  externalExpired,
}) => {
  return (
    <GenericUserManager
      basePath={basePath}
      silentRedirectUri={silentRedirectUri}
      oidcAuthority={oidcAuthority}
      clientId={clientId}
      userManagerType={userManagerTypes.Browser}
      postLogoutRedirectUri={postLogoutRedirectUri}
      onSessionLoaded={onSessionLoaded}
      silentRenewDisabled={silentRenewDisabled}
      externalExpired={externalExpired}
      getWebstorageStateStore={() => new WebStorageStateStore({ store: window.localStorage })}
    >
      {children}
    </GenericUserManager>
  );
};

// ######################################################################################
// ## PropTypes
// ######################################################################################

BrowserUserManager.propTypes = {
  children: PropTypes.node.isRequired,
  basePath: PropTypes.string.isRequired,
  oidcAuthority: PropTypes.string.isRequired,
  clientId: PropTypes.oneOf(Object.values(oidcClientIds)).isRequired,
  postLogoutRedirectUri: PropTypes.string.isRequired,
  silentRedirectUri: PropTypes.string,
  onSessionLoaded: PropTypes.func,
  silentRenewDisabled: PropTypes.bool,
  externalExpired: PropTypes.bool,
};

BrowserUserManager.defaultProps = {
  onSessionLoaded: () => {},
  silentRenewDisabled: false,
  silentRedirectUri: '',
  externalExpired: false,
};

export default BrowserUserManager;
